import React , {useState} from "react";


import { queryClient } from "../../../state/queryClient";
import { useCourtier } from "../../../state/reactquery";


import { axios_cabinetscompagnies_update } from "../../../axios/axios_cabinetscompagnies";
import { axios_emailgestion_sendmailvalidationcompagnie } from "../../../axios/axios_emailgestion";
import { axios_gammesnew_getgammescompagnie } from "../../../axios/axios_gammesnew";
import { axios_courtier_updateauthtarifs } from "../../../axios/axios_courtier";

import { createauth } from "../../../Ecrans/EcranSuperAdmin/utils";

import Button from "../../Buttons/Button";
import FormulaireDemandeGamme from "./FormulaireDemandeGamme";
 
import './ValidationCompagnie.scss' ;
const classNames = require('classnames');

function ValidationCompagnie({infoscompagnie,selectedcompagnie}){
    const {data:courtier}  = useCourtier() ; 
    const [checked, setChecked] = useState(false) ;
    const [loading , setLoading] = useState(false) ;
    const [alertinfosenreg , setAlertinfosenreg] = useState(false) ;
     const [gammes, setGammes] = useState([]) ;

    const coutierauth=courtier?.['autorisation']||{} ; 
    const copycoutierauth = {...coutierauth}  


    // PACK 
    const lancerdemandeauth = async()=>{
        console.log("lancerdemandeauth") ;
        const gammesvalid = gammes.filter(g=>g.nom?.trim()?.length>0) ;

        const jsonsendvalid ={courtier: courtier.nomcommercial ?? courtier.nom_cabinet,
                                code_courtier:infoscompagnie.codecourtier,
                                email_inspecteur:infoscompagnie.email_inspecteur,
                                compagnie_mini : infoscompagnie.compagnie_mini }
          await axios_emailgestion_sendmailvalidationcompagnie({...jsonsendvalid,gammesvalid}); 


        setLoading(true)


        await axios_cabinetscompagnies_update({...infoscompagnie, courtier_auth : 'wait'})

        const reqtouteslesgammes = await axios_gammesnew_getgammescompagnie(infoscompagnie?.compagnie_mini) ;

        const touteslesgammes = reqtouteslesgammes.data ;
        let newcourtierauth = {}
        for(let gamme of touteslesgammes ){
            const listesdestypetarifs = gamme.type_tarif?.split(',') ; 
            for(let type_tarif of listesdestypetarifs ){
                newcourtierauth  = createauth(gamme.compagnie,gamme.gamme,copycoutierauth,gamme.compagnie_mini,gamme.gamme_mini,type_tarif)
            }
        }

        await axios_courtier_updateauthtarifs({id_courtier:courtier.id_courtier ,autorisation: newcourtierauth})  ;
        queryClient.invalidateQueries({ queryKey: ['courtier']})  ;
        queryClient.invalidateQueries({ queryKey: ['datascourtiercompagnies']})  ; 
        setLoading(false);

        setAlertinfosenreg(true) ;
        setTimeout(()=>{setAlertinfosenreg(false) ;}, 5000)
    }

    return (<div  className="validationcompagnie">
                
                <div  className="validationcompagnie_texte1">Souhaitez-vous lancer la demande d’autorisation auprès de {selectedcompagnie?.compagnie} ?</div>
                <div  className="validationcompagnie_texte2">Vous souhaitez autoriser Mutuello à se connecter aux web-services de {selectedcompagnie?.compagnie} en utilisant vos identifiants de connexion.</div>
                <div  className="validationcompagnie_texte2 mb10">Mutuello aura accès uniquement à l’API de tarification, et non à vos dossiers clients, ni à votre extranet. </div>
                  <FormulaireDemandeGamme   gammes={gammes} setGammes={setGammes}  />
                
                <div  className="validationcompagnie_btntexte">
                    <div className={classNames("validationcompagnie_check",{'clicked': checked})} onClick={()=>{setChecked(checked=>!checked)}}></div>
                    <div  className="validationcompagnie_texte1 mb20">Je certifie être partenaire de {selectedcompagnie?.compagnie} et bénéficier d’un droit d’accès aux web-services de la compagnie</div>
                </div>
                <Button texte='Lancer la demande d’autorisation' 
                        color='bouton_color_orange' disable={!checked}
                        loading={loading} 
                        size='bouton_size_normal' 
                        onclick={lancerdemandeauth} />
               
                {alertinfosenreg &&   <span className="alertinfosenreg">Votre demande d’autorisation a été transmise. </span>}

                        <br/><br/>

           </div>)
}


export default ValidationCompagnie